import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import * as moment from 'moment';
import { dynamicSort } from '../../../common/utils/api_utils';
import history from '../../../common/history';
import CustomLoader from '../../common/CustomLoader';
import CustomSelect from '../../../common/formElements/CustomSelect';
import CustomSelectWithValues from '../../../common/formElements/CustomSelectWithValues';

export default class SnippetTemplate extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  state = {
    snippetTypes: [
      { value: 'MODAL', label: 'Modal' },
      { value: 'SNIPPET', label: 'Snippet' },
    ],
    activeTab: '1',
    snapshotName: `Snapshot-${moment().format('YYYY-MMMM-DD-HH-mm-ss-SSS')}`,
    snapshotNameError: '',
  };

  toggle = (activeTab) => {
    this.setState({ activeTab });
  };

  componentDidMount = () => {
    const snippet = this.props.home.selectedSnippet;
    if (snippet.uuid) {
      this.setState({
        snapshotName: `${snippet.name}-Snapshot-${moment().format('YYYY-MMMM-DD-HH-mm-ss-SSS')}`,
      });
    }
  };

  handleChange = (name, value) => {
    if (name === 'snapshotName') {
      this.setState({ [name]: value, snapshotNameError: '' });
    }
  };

  handleSnapshot = () => {
    const { snapshotName } = this.state;
    const { selectedSnippet } = this.props.home;
    if (snapshotName === '' || !snapshotName) {
      this.setState({ snapshotNameError: 'This field is required' });
      return;
    }
    let snippetSnapshotValues = {
      name: snapshotName,
      projectId: this.props.projectId,
      snippetId: selectedSnippet.uuid,
    };
  };

  lastSnippet = (snippets) => {
    return {
      uuid: snippets[this.props.home.snippets.length - 1].uuid,
    };
  };

  createSnippet = (values, resetForm) => {
    const { selectedSnippet } = this.props.home;
  };

  handleDelete = (snippet) => {
    const { currentOpenSnippetId } = this.props;
    if (currentOpenSnippetId && snippet.uuid === currentOpenSnippetId) {
      Swal.fire({
        icon: 'warning',
        title: `${snippet.name}`,
        text: "This snippet is currently in use. So can't be deleted.",
      });
      return;
    }
    Swal.fire({
      text: "You won't be able to revert this.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d30b0b',
      cancelButtonColor: '#757f91',
      confirmButtonText: 'Yes, delete it!',
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return this.props.actions.deleteSnippet({
          projectId: this.props.projectId,
          templateId: snippet.uuid,
        });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
      }
    });
  };

  showAdvanceSnippetSetting = () => {
    const showSnippetSnapshotCreateLoader = this.props.home.deleteSnippetPending;
    const snippet = this.props.home.selectedSnippet;
    const { snapshotName, snapshotNameError, activeTab } = this.state;
    if (snippet.uuid) {
      return (
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label htmlFor="titleTag">Snapshot Name</label>
              <input
                type="text"
                name="snapshotName"
                className="form-control form-control-sm"
                placeholder="Snapshot Name"
                value={snapshotName}
                onChange={(e) => this.handleChange(e.target.name, e.target.value)}
              />
              {snapshotNameError && <p className="text-error">{snapshotNameError}</p>}
              <div className="row p-2">
                <div className="col-12">
                  <div className="text-right">
                    {snippet.uuid && activeTab === '2' ? (
                      <button
                        type="button"
                        className="btn btn-theme-submit btn-sm"
                        disabled={showSnippetSnapshotCreateLoader}
                        onClick={this.handleSnapshot}
                      >
                        <i className="wb webconnect-plus"></i>&nbsp;Create Snapshot&nbsp;
                        <CustomLoader loading={showSnippetSnapshotCreateLoader} />
                      </button>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else return '';
  };

  snippetCopyOptions = (value) => {
    let options = [
      { value: '', label: '- Select One -' },
      { value: 'fromExistingSnippets', label: `${value} from Existing Snippets` },
      { value: 'fromSnippetSnapshots', label: `${value} from Snippet Snapshots` },
    ];
    return options;
  };

  snippetOptions = () => {
    const snippetsToSort = [...this.props.home.snippets];
    let options = [{ value: '', label: '- Select Snippet -' }];
    if (snippetsToSort && snippetsToSort.length > 0) {
      options = options.concat(
        snippetsToSort.sort(dynamicSort('name')).map((e) => {
          return { value: e.uuid, label: e.name };
        }),
      );
    }
    return options;
  };

  snippetSnapshotOptions = () => {
    const { snippetSnapshots } = this.props.home;
    let options = [{ value: '', label: '- Select Snippet Snapshot -' }];
    if (snippetSnapshots.length > 0) {
      const sortedSnapshots = snippetSnapshots.sort(dynamicSort('createdAt')).reverse();
      options = options.concat(
        sortedSnapshots.map((snapshot) => ({
          value: snapshot.uuid,
          label: snapshot.name,
        })),
      );
    }
    return options;
  };

  onSnippetCloneTypeChange = (setFieldValue, values, value) => {
    if (value === '') {
      setFieldValue('snippetType', 'SNIPPET');
      setFieldValue('snippetClone', '');
    } else {
      setFieldValue('snippetType', '');
      setFieldValue('snippetClone', value);
    }
    setFieldValue('snippetCloneFrom', '');
    setFieldValue('snippetRestoreFrom', '');
  };

  showCloneFrom = (values, setFieldValue, setFieldTouched) => {
    const { selectedSnippet } = this.props.home;
    if (!selectedSnippet.uuid) {
      return (
        <div className="form-group">
          <label>Copy Snippet Content (Optional)</label>
          <CustomSelectWithValues
            name={'snippetClone'}
            isMulti={false}
            onBlur={setFieldTouched}
            setFieldValue={setFieldValue}
            //onChange={setFieldValue}
            options={this.snippetCopyOptions('Copy')}
            value={values['snippetClone']}
            onChangeOption={this.onSnippetCloneTypeChange}
            formValues={values}
          />
        </div>
      );
    }
  };

  showExistingSnippetOptions = (values, setFieldValue, setFieldTouched) => {
    const { selectedSnippet } = this.props.home;
    if (!selectedSnippet.uuid && values['snippetClone'] === 'fromExistingSnippets') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'snippetCloneFrom'}
            isMulti={false}
            onBlur={setFieldTouched}
            onChange={setFieldValue}
            options={this.snippetOptions()}
            value={values['snippetCloneFrom']}
          />
        </div>
      );
    } else {
      return '';
    }
  };

  showSnippetSnapshotsOptions = (values, setFieldValue, setFieldTouched) => {
    const { selectedSnippet } = this.props.home;
    if (!selectedSnippet.uuid && values['snippetClone'] === 'fromSnippetSnapshots') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'snippetRestoreFrom'}
            isMulti={false}
            onBlur={setFieldTouched}
            onChange={setFieldValue}
            options={this.snippetSnapshotOptions()}
            value={values['snippetRestoreFrom']}
          />
        </div>
      );
    } else {
      return '';
    }
  };

  prepareValidationForFields = () => {
    let validationSchema = {
      name: Yup.string()
        .required("Name can't be blank")
        .max(100, 'Name can not be more than 100 characters'),
      //snippetType: Yup.string().required("Type can't be blank"),
    };
    return Yup.object().shape(validationSchema);
  };

  render() {
    const { activeTab } = this.state;
    const showSnippetLoader = this.props.home.createSnippetTemplatePending;
    const deleteSnippetLoader = this.props.home.deleteSnippetPending;
    const snippet = this.props.home.selectedSnippet;
    let snippetSchema = {
      name: snippet && snippet.name ? snippet.name : '',
      snippetType: snippet && snippet.snippetType ? snippet.snippetType : 'SNIPPET',
      snippetClone: '',
      snippetCloneFrom: '',
      snippetRestoreFrom: '',
    };
    if (snippet) {
      return (
        <div>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '1' })}
                onClick={() => this.toggle('1')}
              >
                General
              </NavLink>
            </NavItem>
            {snippet.uuid ? (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '2' })}
                  onClick={() => this.toggle('2')}
                >
                  Advance
                </NavLink>
              </NavItem>
            ) : (
              ''
            )}
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Formik
                enableReinitialize={true}
                initialValues={snippetSchema}
                validationSchema={this.prepareValidationForFields()}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setSubmitting(false);
                  this.createSnippet(values, resetForm);
                }}
              >
                {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
                  <Form className="pt-2">
                    <div className="form-group">
                      <label htmlFor="name">Snippet Name</label>
                      <Field
                        type="text"
                        name="name"
                        className="form-control form-control-sm"
                        placeholder="Snippet Name"
                      />
                      <p className="text-danger">
                        <ErrorMessage name={'name'} />
                      </p>
                    </div>
                    {values['snippetClone'] === '' && (
                      <div className="form-group">
                        <label htmlFor="name">Type</label>
                        <CustomSelect
                          name="snippetType"
                          options={this.state.snippetTypes}
                          isMulti={false}
                          onBlur={setFieldTouched}
                          onChange={setFieldValue}
                          value={values['snippetType']}
                          isDisabled={snippet && snippet.uuid ? true : false}
                        />
                        <p className="text-danger">
                          <ErrorMessage name={'snippetType'} />
                        </p>
                      </div>
                    )}

                    {this.showCloneFrom(values, setFieldValue, setFieldTouched)}
                    {this.showExistingSnippetOptions(values, setFieldValue, setFieldTouched)}
                    {this.showSnippetSnapshotsOptions(values, setFieldValue, setFieldTouched)}

                    <div style={{ textAlign: 'right' }}>
                      {snippet && snippet.uuid && (
                        <button
                          type="button"
                          className="btn btn-theme-delete btn-sm"
                          disabled={deleteSnippetLoader}
                          onClick={() => this.handleDelete(snippet)}
                        >
                          <i className="wb webconnect-trash-regular"></i> Delete Snippet&nbsp;
                          <CustomLoader loading={deleteSnippetLoader} />
                        </button>
                      )}
                      &nbsp;
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-sm"
                        disabled={isSubmitting || showSnippetLoader}
                      >
                        <i className="wb webconnect-plus"></i>
                        {snippet && snippet.uuid ? 'Update' : 'Create'} Snippet&nbsp;
                        <CustomLoader loading={showSnippetLoader} />
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </TabPane>
            <TabPane tabId="2">{this.showAdvanceSnippetSetting()}</TabPane>
          </TabContent>
        </div>
      );
    } else {
      return '';
    }
  }
}
